import { RendererThis, MarkedExtension, Tokens } from 'marked'

const useAddClassesExtension = (): MarkedExtension => {
  const classExtension: MarkedExtension = {
    renderer: {
      code(token: Tokens.Code) {
        const lang = (token.lang || '').trim()
        const cls = lang ? ` class="language-${lang}"` : ''
        return `<pre><code${cls}>${token.text}</code></pre>\n`
      },
      heading(this: RendererThis, token: Tokens.Heading) {
        const { depth } = token
        return `<p class="md-heading md-h${depth}"><strong>${this.parser.parseInline(token.tokens)}</strong></p>\n`
      },
      listitem(this: RendererThis, token: Tokens.ListItem) {
        const blocks = token.tokens ?? []
        if (!token.task) {
          return `<li>${this.parser.parse(blocks ?? [])}</li>\n`
        }
        return `<li class="task-list-item">${this.parser.parse(blocks)}</li>\n`
      },
      list(this: RendererThis, token: Tokens.List) {
        const tag = token.ordered ? 'ol' : 'ul'

        const isTaskList = token.items?.some((i) => i.task)
        const cls = token.ordered
          ? 'md-ol'
          : isTaskList
            ? 'md-ul task-list'
            : 'md-ul'

        const startAttr =
          token.ordered && typeof token.start === 'number' && token.start !== 1
            ? ` start="${token.start}"`
            : ''

        const body = token.items
          .map((item) => this.parser.renderer.listitem(item))
          .join('')

        return `<${tag}${startAttr} class="${cls}">\n${body}</${tag}>\n`
      },
    },
  }

  return classExtension
}

export default useAddClassesExtension
